import type { ReactNode } from "react";

type BulkDownloadsPageContainerProps = {
  children: ReactNode;
};

const BulkDownloadsPageContainer = ({
  children,
}: BulkDownloadsPageContainerProps) => {
  return <>{children}</>;
};

export default BulkDownloadsPageContainer;
